import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileEdit, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';

const emptyAddress = {
    friendly_name: '',
    company: '',
    address: '',
    postcode: '',
    additional_info: '',
};

const AddressBookPanel = ({ addresses, canEdit, onSave, onDelete }) => {
    const [search, setSearch] = useState('');
    const [editing, setEditing] = useState(null);
    const [formOpen, setFormOpen] = useState(false);
    const [formData, setFormData] = useState(emptyAddress);
    const [error, setError] = useState('');

    const openForm = (address = null) => {
        setEditing(address);
        setFormOpen(true);
        setFormData(address ? { ...address, additional_info: address.additional_info || '' } : emptyAddress);
        setError('');
    };

    const submit = async () => {
        if (!formData.friendly_name.trim() || !formData.company.trim() || !formData.address.trim() || !formData.postcode.trim()) {
            setError('Friendly name, company, address and postcode are required.');
            return;
        }
        const saved = await onSave({ ...formData, postcode: formData.postcode.toUpperCase() });
        if (saved) {
            setEditing(null);
            setFormOpen(false);
        }
    };

    const filtered = addresses.filter((item) => {
        const haystack = `${item.friendly_name} ${item.company} ${item.address} ${item.postcode}`.toLowerCase();
        return haystack.includes(search.toLowerCase());
    });

    return (
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'center', marginBottom: 20 }}>
                <div>
                    <h3 style={{ marginBottom: 4 }}>Address Book</h3>
                    <span style={{ opacity: 0.65 }}>{addresses.length} saved locations</span>
                </div>
                {canEdit && <button className="btn btn-primary" onClick={() => openForm()}><FontAwesomeIcon icon={faPlus} style={{ width: 14 }} /> Add Address</button>}
            </div>
            <input
                className="form-control"
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="Search friendly name, company, address or postcode..."
                style={{ marginBottom: 18 }}
            />
            <div style={{ display: 'grid', gap: 10 }}>
                {filtered.map((item) => (
                    <div key={item.id} style={{ border: '1px solid rgba(128,128,128,0.35)', borderRadius: 6, padding: 16, display: 'flex', justifyContent: 'space-between', gap: 20 }}>
                        <div>
                            <strong style={{ fontSize: '1.05rem' }}>{item.friendly_name}</strong>
                            <div>{item.company}</div>
                            <div style={{ opacity: 0.75 }}>{item.address}, {item.postcode}</div>
                            {item.additional_info && <div style={{ marginTop: 6, opacity: 0.65 }}>{item.additional_info}</div>}
                        </div>
                        {canEdit && (
                            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                                <button type="button" className="btn btn-link" title="Edit address" onClick={() => openForm(item)}><FontAwesomeIcon icon={faFileEdit} style={{ width: 16 }} /></button>
                                <button type="button" className="btn btn-link text-danger" title="Delete address" onClick={() => onDelete(item)}><FontAwesomeIcon icon={faTimes} style={{ width: 16 }} /></button>
                            </div>
                        )}
                    </div>
                ))}
                {filtered.length === 0 && <p style={{ textAlign: 'center', opacity: 0.55, marginTop: 30 }}>No addresses found.</p>}
            </div>

            {formOpen && (
                <div className="overlay">
                    <div className="modal-container">
                        <h2>{editing?.id ? 'Edit Address' : 'Add Address'}</h2>
                        <form className="form two-column" onSubmit={(event) => { event.preventDefault(); submit(); }}>
                            {[
                                ['friendly_name', 'Friendly Name', 'THG Warrington'],
                                ['company', 'Company', 'THG'],
                                ['address', 'Address', 'Omega Boulevard, Warrington'],
                                ['postcode', 'Postcode', 'WA5 3BD'],
                            ].map(([name, label, placeholder]) => (
                                <div className="input-group" key={name}>
                                    <label htmlFor={`address-book-${name}`}>{label} *</label>
                                    <input id={`address-book-${name}`} className="input" value={formData[name]} placeholder={placeholder} onChange={(event) => setFormData((previous) => ({ ...previous, [name]: event.target.value }))} />
                                </div>
                            ))}
                            <div className="input-group" style={{ gridColumn: '1 / -1' }}>
                                <label htmlFor="address-book-additional-info">Additional Information</label>
                                <textarea id="address-book-additional-info" className="input" rows={3} value={formData.additional_info} onChange={(event) => setFormData((previous) => ({ ...previous, additional_info: event.target.value }))} />
                            </div>
                        </form>
                        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
                        <div className="button-group">
                            <button className="submit-button" onClick={submit}>Save Address</button>
                            <button className="close-button" onClick={() => { setEditing(null); setFormOpen(false); }}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddressBookPanel;